<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.errorWeChatSubscribeList.push"
    :is-show-search-input="false"
  >
    <v-column-time/>
    <el-table-column label="ID" prop="id" width="100px"/>
    <el-table-column label="学员" width="180px">
      <template slot-scope="{ row }">
        <v-avatar-nickname :value="row.selfie" :nickname="row.student_name"/>
      </template>
    </el-table-column>
    <el-table-column label="消息名" prop="message_name" width="160px"/>
    <el-table-column label="模板键" prop="template_key" width="150px"/>
    <el-table-column label="错误码" prop="errcode" width="100px"/>
    <el-table-column label="错误消息" prop="errmsg">
      <template slot-scope="{ row }">
        <div class="overflow-box">{{ row.errmsg }}</div>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`error-subscribe-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>学员</span>
              <v-avatar-nickname :value="v.selfie" :nickname="v.student_name" :avatar-size="50" width="30vw"/>
            </div>
            <div class="list-item-detail">
              <span>消息名</span>
              <span>{{ v.message_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>错误码</span>
              <span>{{ v.errcode }}</span>
            </div>
            <div class="list-item-detail">
              <span class="flex-shrink">错误消息</span>
              <span class="list-item-info">{{ `${v.errmsg}${v.errmsg && v.errmsg.length > 31 ? '……' : ''}` }}</span>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { getWeChatSubscribeList } from '@/api/error-log';

export default {
  name: RouteConfig.errorWeChatSubscribeList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getWeChatSubscribeList(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
<style src="./index.css" scoped/>
